import { render, staticRenderFns } from "./RevisitDialog.vue?vue&type=template&id=6c1d1661&"
import script from "./RevisitDialog.vue?vue&type=script&lang=js&"
export * from "./RevisitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports